export default __webpack_public_path__ + "images/HK.27b6cba.png";